import React, { useState, useEffect, useRef } from "react";
import { Layout } from "antd";
import { Button } from "antd";
import "./index.scss";
import axiosInstance from "@/axios/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import tool from "@/assets/tool";
const DataDetailPage = () => {
  let navigate = useNavigate();
  const [dataDetail, setDatali] = useState({});
  const [dataset, setData] = useState([]);
  const [user, setUser] = useState({});
  let location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");
  useEffect(() => {
    if (id) {
      fetchDetails(id); // 如果id存在，
      let user = {
        nickName: nickName,
        profilePictureUrl: profilePictureUrl,
      };
      setUser(user);
      getOthCom();
    }
  }, [id]); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `serviceManager/page/detail?serviceManagerId=${id}`
      );
      let data = response.data.data;
      setDatali(data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  const getOthCom = async (a) => {
    try {
      const response = await axiosInstance.get(`serviceManager/page/list`);
      let compute = response.data.data.length
        ? response.data.data.slice(0, 3)
        : [];
      setData(compute);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  const toDetail = (record) => {
    navigate("/dataset_detail", {
      state: {
        id: record.computPowerId,
        profilePictureUrl: record.profilePictureUrl,
        nickName: record.nickName,
      },
    });
  };
  const getLabel = (l) => {
    let label = "";
    if (l) {
      const bq = [
        { key: "1", value: "AI规划咨询" },
        { key: "2", value: "AI系统方案设计 " },
        { key: "3", value: "AI数据处理" },
        { key: "4", value: "AI模型训练" },
        { key: "5", value: "AI产品开发" },
        { key: "6", value: "AI模型部署" },
        { key: "11", value: "AI聊天" },
        { key: "22", value: "AI绘画 " },
        { key: "33", value: "AI视频" },
        { key: "44", value: "AI语言处理" },
        { key: "55", value: "AI办公效率提升" },
        { key: "66", value: "AI审计风控" },
      ];
      label = bq.find((v) => v.key == l).value;
    }

    console.log(label);
    return label;
  };
  const getTypeLabel = (l) => {
    let label = "";
    if (l) {
      const bq = [
        { key: "1", value: "按时付费" },
        { key: "2", value: "按需定制  " },
        { key: "3", value: "标准定价" },
      ];
      label = bq.find((v) => v.key == l).value;
    }
    return label;
  };
  return (
    <Layout className="compute_datail">
      <div className="ompute-hea">
        <div className="name">服务详情</div>
        <div className="name name_titke">{dataDetail.title}</div>
        <div className="name_time">
          {user.nickName} 于{dataDetail.createTime}发布
          <div className="com_label">
            <span>服务类型：</span>
            <span>{getLabel(dataDetail.serviceType)}</span>
            <span className="xinx fileUnit">服务主体：</span>
            <span>{dataDetail.servicePrincipal}</span>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="table-content">
          <div className="table-container">
            <div className="table_name">
              <h3>服务介绍</h3>
            </div>
            <div className="row">
              <div
                dangerouslySetInnerHTML={{ __html: dataDetail.introduction }}
                className="ql-editor"
              />
            </div>
          </div>
        </div>
        <div className="right">
          <div className="top">
            <div className="child send">
              <span>
                <img
                  src={`/file/${user.profilePictureUrl}`}
                  className="tx"
                  alt=""
                />
                <span className="nickName">
                  {user.nickName || tool.hideMiddleFour(user.phone)}
                </span>
              </span>
              <Button type="primary" disabled>
                关注
              </Button>
            </div>
          </div>
          <div className="comp">
            <div>
              <span className="shoufei">收费方式：</span>
              {getTypeLabel(dataDetail.paymentType)}
            </div>
            <div className="totalPice"> ￥ {dataDetail.paymentPrice} 元 </div>
            <div className="xinx">
              <span className="com_d">购买单价：</span>
              {dataDetail.paymentPrice} 元
            </div>
            <div className="mone">
              {/*<div className='xinx'><span className='com_d'>购买数量 ：</span> {1}组</div>*/}
            </div>
          </div>
        </div>
      </div>
      <div className="detail_bott_mes">
        <div className="detail_mes">
          <p>信息声明：</p>
          <div>
            渐风AI上的所有商品信息等内容，是渐风AI重要的经营资源，未经许可，禁止非法转载使用。
          </div>

          <div>
            注：本站商品信息均来自于发布用户，其真实性、准确性和合法性由信息拥有者（发布用户）负责。本站不提供任何保证，并不承担任何法律责任。
          </div>
        </div>
        <div className="detail_mes">
          <p> 价格说明：</p>
          <div>
            价格：价格为商品的销售价格，是您最终决定是否购买商品的依据。
          </div>

          <div>
            异常问题：商品的具体售价以订单结算页价格为准，如您发现商品售价或商品信息有异常，建议您购买前先联系发布用户咨询。
          </div>
        </div>
      </div>
      <div className="detail_bott">
        <h3>推荐服务</h3>
        <div className="tui_data">
          {dataset.map((v, index) => {
            return (
              <div className="data_to">
                <div className="cont-san" key={v.id}>
                  <div className="con_t">
                    <div>{index + 1}.</div>
                    <div
                      className="title"
                      onClick={() => toDetail(v)}
                      title={v.title}
                    >
                      {v.title}
                    </div>
                  </div>
                  <div className="cont-l">
                    {v.fileSize}
                    {v.fileUnit}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default DataDetailPage;
